import React from "react";
import { RequestStatusCards } from "../RequestStatusCards";

// All / Pending / Approved / Rejected / Cancelled tallies. Clicking a tile
// keeps that status selected (activeStatus). "All" (empty filter value)
// shows the grand total and clears any active filter. Shared by Attendance
// Correction and Shift Correction; rendered through RequestStatusCards so
// both match Team Workspace > Approvals' status cards.
export const CorrectionStatusTiles = ({ counts, total, activeStatus, onSelect }) => (
  <RequestStatusCards
    counts={counts}
    total={total}
    activeStatus={activeStatus}
    onSelect={onSelect}
  />
);
